const today = new Date().toLocaleDateString(undefined, { day: '2-digit', month: '2-digit', year: 'numeric' })

export const checkIsAvailableForRentInFuture = (isAvailableForRentNow: boolean, for_rent?: Record<string, string | null>) => {
  const forRentDates = Object.values(for_rent || {})
  const isAvailableForRentInFuture = (forRentDates.length > 0 && forRentDates.some(date => date !== today))
  return {
    showWarning: !isAvailableForRentNow && !isAvailableForRentInFuture && forRentDates.length > 0,
    isAvailableForRentInFuture,
    forRentDates
  }
}

export const checkIsMoreThanOneCategory = (types: any[]) => {
  if (types && Array.isArray(types) && types.length > 1) {
    const firstTypeRentableType = types[0]?.defaultCategoryId?.value
    for (const type of types) {
      if (type?.defaultCategoryId?.value !== firstTypeRentableType) {
        return true
      }
    }
  }

  return false
}

export const generateTablesOfUniqueCategories = (types: any[]) => {
  const list: Record<string, any> = {}
  if (types && Array.isArray(types) && types.length > 0) {
    for (const type of types) {
      if (type.defaultCategoryId) {
        list[type.defaultCategoryId.value] = type.defaultCategoryId
      }
    }
  }

  return Object.values(list)
}

export const generateParkingPositionTables = (warehouses: Record<string, Record<string, any>>) => {
  if (!warehouses || typeof warehouses !== 'object') {
    return []
  }

  const list = []
  for (const typeKey in warehouses) {
    const type = warehouses[typeKey]
    if (type && typeof type === 'object') {
      for (const hash in type) {
        const variant = type[hash]
        if (variant?.rentableType === 'parking') {
          list.push({ ...variant, hash })
        }
      }
    }
  }

  return list
}

export const generateCategoryPositionTables = (warehouses: Record<string, Record<string, any>>, categoryId: string, onlyFirstVariant?: boolean) => {
  if (!warehouses || typeof warehouses !== 'object') {
    return []
  }

  const list = []
  for (const typeKey in warehouses) {
    const type = warehouses[typeKey]
    if (type && typeof type === 'object') {
      if (onlyFirstVariant) {
        const firstKey = Object.keys(type)[0]
        if (firstKey && type[firstKey]?.data?.categoryId === categoryId) {
          list.push({ ...type[firstKey], hash: firstKey })
        }

      } else {
        for (const hash in type) {
          const variant = type[hash]
          if (variant?.data?.categoryId === categoryId) {
            list.push({ ...variant, hash })
          }
        }
      }
    }
  }

  return list
}